import styled, { css } from 'styled-components';
import { layout } from '../../../package.json';

interface MenuProps {
  open?: boolean;
}

export const Container = styled.button<MenuProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  border: 0;

    ${props =>
    props.open === false &&
    css`
      display: none;
    `}

    background-color: rgba(0, 0, 0, 0.6);

    @media (min-width: ${layout.desktop}) {
    display: none;
    }

    z-index: 9998;
`;

export const ContainerMenu = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  width: 70%;
  height: 100vh;
  min-width: 150px;
  max-width: 500px;
  min-height: 500px;
  max-height: 700px;
  z-index: 9999;
`;